import React, { cloneElement } from 'react';
import { motion } from 'framer-motion';
import { Layers, FileText, ShoppingBag, FlaskConical, Star, Download } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: <Layers data-id="element-124" />,
    text: 'Módulos y lecciones paso a paso'
  }, {
    icon: <FileText data-id="element-125" />,
    text: 'Guías prácticas descargables'
  }, {
    icon: <ShoppingBag data-id="element-126" />,
    text: 'Lista de materiales recomendados'
  }, {
    icon: <FlaskConical data-id="element-127" />,
    text: 'Recetas y fórmulas base'
  }, {
    icon: <Star data-id="element-128" />,
    text: 'Tips de presentación y acabados profesionales'
  }, {
    icon: <Download data-id="element-129" />,
    text: 'Bonus descargables exclusivos'
  }];
  return <section className="py-20 bg-white" data-id="element-130">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-132">
          <h2 className="font-serif text-3xl md:text-4xl text-artisanal-brown font-bold mb-4" data-id="element-133">
            ¿Qué incluye el programa?
          </h2>
          <p className="font-sans text-lg text-artisanal-brown/70" data-id="element-134">
            Todo lo que necesitas para comenzar tu viaje artesanal.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-135">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center p-8 rounded-2xl bg-artisanal-cream border border-artisanal-beige hover:border-artisanal-sage/30 transition-colors" data-id="element-136">
              <div className="text-artisanal-terracotta mb-4 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm" data-id="element-137">
                {cloneElement(item.icon as React.ReactElement, {
              className: 'w-6 h-6'
            })}
              </div>
              <p className="font-sans font-medium text-artisanal-brown" data-id="element-138">
                {item.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}